
import useSessionStorage from './useSessionStorage';

export const VIEW = Object.freeze({
  normal: 'normal',
  cashier: 'cashier'
});

/**
 * Parses 'view' query string parameter and caches for the session.
 * @returns {string} current view
 */
function useView() {
  const [view, setView] = useSessionStorage('vip-view');
  const params = new URLSearchParams(window.location.search);
  var paramView = VIEW.normal;
  if (!sessionStorage.getItem('vip-view') && params.get('view')) {
    paramView = params.get('view');
    setView(paramView);
    return paramView;
  }
  else {
    if (sessionStorage.getItem('vip-view')) {
      paramView = sessionStorage.getItem('vip-view');
    }
    else {
      setView(VIEW.normal);
    }
   }
  return view;
};

export default useView;
